import consumer from './consumer'

$(document).on('turbolinks:load', function () {
  var organization_id = $('#organization_id').data('id');
  consumer.subscriptions.create({
    channel: 'ScanChannel',
    room: organization_id
  }, {
    connected() {
      // Called when the subscription is ready for use on the server
      console.log('Connected to the room!');
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
      console.log('disconnected');
    },

    received(data) {
      // Called when there's incoming data on the websocket for this channel
      // console.log('Recieving:', data);

      var notificationStatus = 'primary';

      if (data.status == 'error') {
        notificationStatus = 'danger';

        scanCheck(data.scan_id);
      } else if (data.status == 'started') {
        console.log('started scan', data);
      } else if (data.status == 'running') {
        notificationStatus = 'primary';

        scanCheck(data.scan_id);
      } else if (data.status == 'finished') {
        notificationStatus = 'success';

        scanCheck(data.scan_id);
      }

      var notificationMessage = 'Scan: ' + data.status;

      UIkit.notification({
          message: notificationMessage,
          status: notificationStatus,
          pos: 'top-center',
          timeout: 3000
      });
    }
  });
});

var varBJC = setInterval(function() {
  scanCheck(0, 'all');
}, 7000);

function scanCheck(scanId) {
  var remaining = 5;

  var scan_page = $('#scan_page').val();
  var scan_status = $('#scan_status').val();

  console.log(scan_page, scan_status);

  if (scan_page == 'scan_overview' && scanId == 0) {
    var scanId = $('#scan_id').val();
  }

  $.ajax({
    data: { scan_id: scanId, came_from: scan_page },
    method: 'GET',
    url: '/scans/update_scan',
    success: function(data) {
      console.log('data', data);

      if (data.scans == undefined) {
        $('#js-progressbar').val(data.progress);
        $('#js-progressbar-b').html(data.progress + '%');

        if (data.progress == 100) {
          $('#js-progressbar').removeClass('progress-blue');
          $('#js-progressbar').addClass('progress-green');
          $('#js-progressbar-div .in-progress-message').hide();
          $('#js-progressbar-div .finished-progress-message').show();
          $('.uk-card-line-loading.in-progress-message').fadeOut();
          $('.uk-card-line-loading.finished-progress-message').fadeIn();
          myStopFunction();
          if (scan_status == 'running')
            reloadPage(remaining);
        } else {
          $.each(data.risk_services, function(i, item) {
            if (item.total_uniq_executed_checks == item.total_uniq_checks) {
              $('.uk-card-line-loading .background.background-' + item.service_slug + '.background__running').removeClass('background__running');
              $('.uk-card-line-loading .background.background-' + item.service_slug).addClass('background__pass');
            } else {
              $('.uk-card-line-loading .background.background-' + item.service_slug + '.background__pass').removeClass('background__pass');
              $('.uk-card-line-loading .background.background-' + item.service_slug).addClass('background__running');
            }
            $('.progress-' + item.service_slug).html(item.total_uniq_executed_checks);
          });
        }
      } else {
        if (data.progress_total.has_running_scan == false)
          myStopFunction();

        $.each(data.scans, function(i, item) {
          // console.log('item', item);
          if ((item.scan_status == 'running' || item.scan_status == 'created' || item.scan_status == 'started') && item.progress < 100) {
            $('.scan-history-' + item.scan_id + ' .finished-scan').hide();
            $('.scan-history-' + item.scan_id + ' .progress-scan').show();
            $('.scan-history-' + item.scan_id + ' .scan-history-labels.background').addClass('background__running');
            $('.scan-history-' + item.scan_id + ' .scan-progress-line').html(item.total_executed_checks);
            $('.scan-history-' + item.scan_id + ' .scan-progress-line-total').html(item.total_checks);
          } else {
            $('.scan-history-' + item.scan_id + ' .progress-scan').hide();
            $('.scan-history-' + item.scan_id + ' .scan-history-labels .in-progress-message').hide();
            $('.scan-history-' + item.scan_id + ' .scan-history-labels.background').removeClass('background__running');
            $('.scan-history-' + item.scan_id + ' .finished-scan .pass').html(item.total_pass_checks);
            $('.scan-history-' + item.scan_id + ' .finished-scan .fail').html(item.total_fail_checks);
            $('.scan-history-' + item.scan_id + ' .finished-scan .warning').html(item.total_warn_checks);
            $('.scan-history-' + item.scan_id + ' .finished-scan .info').html(item.total_info_checks);
            $('.scan-history-' + item.scan_id + ' .finished-scan').fadeIn();

            $('.scan-history-' + item.scan_id + ' .uk-icon-button').hide();

            if (item.scan_status == 'finished') {
              $('.scan-history-' + item.scan_id + ' .uk-icon-button.uk-text-success').attr('style', 'display: inline-flex!important;');
            } else if (item.scan_status == 'error') {
              $('.scan-history-' + item.scan_id + ' .uk-icon-button.uk-text-danger').attr('style', 'display: inline-flex!important;');
            } else {
              $('.scan-history-' + item.scan_id + ' .uk-icon-button.uk-text-primary').attr('style', 'display: inline-flex!important;');
            }
          }
        });
      }
    },
    error: function(data) {
      // console.log('error', data);
      myStopFunction();
    }
  });
}

function reloadPage(remaining) {
    var stopTimeOut = setTimeout(function() {
      // console.log('remaining', remaining)
      remaining = remaining - 1;
      $('.uk-card-line-loading .countdown').html(remaining);
      reloadPage(remaining);
    }, 1000);

    if (remaining <= 0) {
      // console.log('end countdown');
      clearInterval(stopTimeOut);
      setTimeout(function() {
        location.reload(true);
      }, 500);
    }
}

function myStopFunction() {
  // console.log('stopFunction');
  clearInterval(varBJC);
}
